(function () {
    'use strict';
  
    function getSdk() {
      const sharedGetter = window.etRechargeUtils?.getSharedRechargeSdk;
      if (typeof sharedGetter === 'function') {
        return sharedGetter();
      }
      const sdk = window.etRechargeSdk;
      if (!sdk || typeof sdk.getMethod !== 'function') {
        throw new Error(
          'Recharge SDK is unavailable. Load recharge-sdk-bootstrap.js before this script.'
        );
      }
      return sdk;
    }
  
    function getMethod(pathSegments) {
      const sharedGetter = window.etRechargeUtils?.getRechargeMethod;
      if (typeof sharedGetter === 'function') {
        return sharedGetter(pathSegments);
      }
      return getSdk().getMethod(pathSegments);
    }
  
    function getOptionalMethod(pathSegments) {
      try {
        return getMethod(pathSegments);
      } catch (_) {
        return null;
      }
    }
  
    let sessionPromise = null;  
    
    async function getPortalSession() {
      const sharedGetPortalSession = window.etRechargeUtils?.getPortalSession;
      if (typeof sharedGetPortalSession === 'function') {
        return sharedGetPortalSession();
      }
      if (sessionPromise) return sessionPromise;
      const sdk = getSdk();
      if (typeof sdk.ready !== 'function') {
        throw new Error('Recharge SDK ready() is unavailable.');
      }
      await sdk.ready();
      const loginCustomerPortal = getMethod(['auth', 'loginCustomerPortal']);
      sessionPromise = loginCustomerPortal();
      try {
        return await sessionPromise;
      } catch (err) {
        sessionPromise = null;
        throw err;
      }
    }  
    
    async function getChurnLandingPageUrl(session, subscriptionId, redirectUrl) {
      const paths = [
        ['customer', 'getActiveChurnLandingPageURL'],
        ['customer', 'getActiveChurnLandingPageUrl'],
        ['churn', 'getActiveChurnLandingPageURL'],
        ['churn', 'getActiveChurnLandingPageUrl'],
        ['getActiveChurnLandingPageURL'],
        ['getActiveChurnLandingPageUrl'],
      ];
      let method = null;
      for (let i = 0; i < paths.length; i++) {
        method = getOptionalMethod(paths[i]);
        if (method && typeof method === 'function') break;
      }
      if (!method || typeof method !== 'function') {
        throw new Error(
          'Recharge getActiveChurnLandingPageURL is unavailable. Ensure your Recharge SDK supports churn/cancellation (Customer API).'
        );
      }
      const result = method(session, String(subscriptionId), redirectUrl);
      return Promise.resolve(result).then(function (res) {
        if (typeof res === 'string' && res.trim()) return res.trim();
        if (res && typeof res === 'object' && typeof res.url === 'string')
          return res.url.trim();
        if (res && typeof res === 'object' && typeof res.data === 'string')
          return res.data.trim();
        return null;
      });
    }  
   
    async function redirectToChurnPage(subscriptionId, redirectUrl) {
      let url =
        typeof redirectUrl === 'string' && redirectUrl.trim()
          ? redirectUrl.trim()
          : window.location.origin + (window.location.pathname || '/account');
      if (!url.startsWith('http')) {
        url = window.location.origin + (url.startsWith('/') ? url : '/' + url);
      }
      const session = await getPortalSession();
      const churnUrl = await getChurnLandingPageUrl(
        session,
        String(subscriptionId),
        url
      );
      if (churnUrl && typeof churnUrl === 'string' && churnUrl.trim()) {
        window.location.href = churnUrl;
        return;
      }
      throw new Error('Invalid churn URL returned from Recharge.');
    }  
    
    function clearPortalSessionCache() {
      sessionPromise = null;
    }  
    
    function showCancelSubscriptionModal(subscriptionId, options) {
      const opts = options && typeof options === 'object' ? options : {};
      const onError = typeof opts.onError === 'function' ? opts.onError : null;
      let releaseFocusTrap = null;
      const previousFocusedElement =
        document.activeElement instanceof HTMLElement ? document.activeElement : null;

      const overlay = document.createElement('div');
      overlay.className = 'et-cancel-subscription-modal';
      overlay.setAttribute('role', 'dialog');
      overlay.setAttribute('aria-modal', 'true');
      overlay.setAttribute('aria-labelledby', 'et-cancel-subscription-modal-title');
      const dialog = document.createElement('div');
      dialog.className = 'et-cancel-subscription-modal__dialog';
      dialog.innerHTML =
        '<div class="et-cancel-subscription-modal__header">' +
        '<h2 id="et-cancel-subscription-modal-title" class="et-cancel-subscription-modal__title">Cancel subscription?</h2>' +
        '<button type="button" class="et-cancel-subscription-modal__close" aria-label="Close">&times;</button>' +
        '</div>' +
        '<div class="et-cancel-subscription-modal__body">' +
        '<p class="et-cancel-subscription-modal__intro">Are you sure you want to cancel? You\'ll be taken to a page where you can confirm or change your mind.</p>' +
        '<div class="et-cancel-subscription-modal__actions">' +
        '<button type="button" class="et-cancel-subscription-modal__keep">Keep subscription</button>' +
        '<button type="button" class="et-cancel-subscription-modal__confirm">Continue to cancellation</button>' +
        '</div>' +
        '</div>';
      overlay.appendChild(dialog);
  
      function closeModal() {
        if (typeof releaseFocusTrap === 'function') {
          releaseFocusTrap();
          releaseFocusTrap = null;
        }
        overlay.remove();
        document.body.style.overflow = '';
        if (
          previousFocusedElement instanceof HTMLElement &&
          document.contains(previousFocusedElement)
        ) {
          previousFocusedElement.focus();
        }
      }
  
      const closeBtn = dialog.querySelector('.et-cancel-subscription-modal__close');
      const keepBtn = dialog.querySelector('.et-cancel-subscription-modal__keep');
      const confirmBtn = dialog.querySelector('.et-cancel-subscription-modal__confirm');
      closeBtn.addEventListener('click', closeModal);
      keepBtn.addEventListener('click', closeModal);
      overlay.addEventListener('click', function (e) {
        if (e.target === overlay) closeModal();
      });
      dialog.addEventListener('click', function (e) {
        e.stopPropagation();
      });
  
      confirmBtn.addEventListener('click', function () {
        keepBtn.disabled = true;
        confirmBtn.disabled = true;
        confirmBtn.textContent = 'Loading…';
        const redirectUrl =
          window.location.origin + (window.location.pathname || '/account');
        redirectToChurnPage(subscriptionId, redirectUrl).catch(function (err) {
          if (typeof console !== 'undefined' && console.error) {
            console.error(
              '[etRechargeSubscriptionCancel] Cancel redirect failed:',
              err
            );
          }
          const msg =
            err && err.message
              ? err.message
              : 'Unable to open cancellation page. Please try again.';
          if (onError) onError(msg);
        });
      });
  
      document.body.style.overflow = 'hidden';
      document.body.appendChild(overlay);
      function handlePageHide() {
        try {
          closeModal();
        } catch (error) {
          console.error('[Cancel Subscriptions] Failed to close modal:', error);
        }
        window.removeEventListener('pagehide', handlePageHide);
      }
      window.addEventListener('pagehide', handlePageHide);
      const trapFocus = window.etRechargeUtils?.trapFocus;
      if (typeof trapFocus === 'function') {
        releaseFocusTrap = trapFocus(dialog, {
          onEscape: closeModal,
          initialFocus: keepBtn,
        });
      }
    }  
    
    function getActiveChurnLandingPageURL(session, subscriptionId, redirectUrl) {
      return getChurnLandingPageUrl(session, subscriptionId, redirectUrl);
    }
    
    function showCancelSubscriptionModalFallback(subscriptionId, options) {
      return showCancelSubscriptionModal(subscriptionId, options);
    }
    
    function handleCancelSubscriptionClick(event, options) {
      const target = event && event.target instanceof Element ? event.target : null;
      if (!target) return false;
      const cancelTrigger = target.closest('[data-action="et-cancel-subscription"]');
      if (!cancelTrigger || !(cancelTrigger instanceof HTMLElement)) return false;

      event.preventDefault();
      event.stopPropagation();

      const opts = options && typeof options === 'object' ? options : {};
      const getFallback = typeof opts.getFallbackSubscriptionId === 'function' ? opts.getFallbackSubscriptionId : null;
      const parseId = typeof opts.parseSubscriptionId === 'function' ? opts.parseSubscriptionId : function (v) {
        if (v === null || v === undefined) return null;
        const n = parseInt(String(v), 10);
        return (typeof n === 'number' && isFinite(n) && n > 0) ? n : null;
      };
      const onError = typeof opts.onError === 'function' ? opts.onError : null;

      let rawId = cancelTrigger.getAttribute('data-subscription-id');
      if (rawId === null || rawId === undefined) rawId = getFallback ? getFallback() : null;
      const subscriptionId = parseId(rawId);

      if (!subscriptionId) {
        if (onError) onError('Subscription is still loading. Please try again.');
        return true;
      }

      const details = cancelTrigger.closest('details');
      if (details) details.removeAttribute('open');

      const showModalFn = showCancelSubscriptionModalFallback || showCancelSubscriptionModal;
      showModalFn(subscriptionId, { onError: onError });
      return true;
    }
    
    function handleDocumentClickForCancel(event) {
      const target = event && event.target instanceof Element ? event.target : null;
      if (!target) return;
      const cancelTrigger = target.closest('[data-action="et-cancel-subscription"]');
      if (!cancelTrigger || !(cancelTrigger instanceof HTMLElement)) return;

      const integration = window.etRechargeSubscriptionCancelIntegration;
      const opts = integration && typeof integration === 'object' ? integration : {};
      handleCancelSubscriptionClick(event, {
        getFallbackSubscriptionId: typeof opts.getFallbackSubscriptionId === 'function' ? opts.getFallbackSubscriptionId : null,
        parseSubscriptionId: typeof opts.parseSubscriptionId === 'function' ? opts.parseSubscriptionId : null,
        onError: typeof opts.onError === 'function' ? opts.onError : null,
      });
    }

    document.addEventListener('click', handleDocumentClickForCancel, true);
    
    function redirectToSubscriptionCreateIfNoActive(activeSubscriptionCount, redirectPath) {
      const path = typeof redirectPath === 'string' && redirectPath.trim()
        ? redirectPath.trim()
        : 'pages/subscriptions';
      if (Number.isFinite(Number(activeSubscriptionCount)) && Number(activeSubscriptionCount) === 0) {
        const url = path.startsWith('http') ? path : (window.location.origin + (path.startsWith('/') ? path : '/' + path));
        window.location.href = url;
      }
    }

    function isPaymentMethodsPage() {
      try {
        const href = String(window.location.href || '');
        const search = String(window.location.search || '');
        return href.indexOf('payment_methods') !== -1 || search.indexOf('payment_methods') !== -1;
      } catch (error){
        console.error('[Cancel Subscriptions] Failed to check if payment methods page:', error);
        return false;
      }
    }

    async function loadActiveSubscriptionsWithSummaries() {
      const ext = window.etUpdateMealsExtensions || {};
      const getPortalSessionExt = typeof ext.getPortalSession === 'function' ? ext.getPortalSession : null;
      const getSubscriptionsExt = typeof ext.getSubscriptions === 'function' ? ext.getSubscriptions : null;
      const listChargesExt = typeof ext.listCharges === 'function' ? ext.listCharges : null;

      async function basicList() {
        const session = await getPortalSession();
        const listSubs = getOptionalMethod(['subscription', 'listSubscriptions']);
        if (typeof listSubs !== 'function') {
          throw new Error(
            '[Cancel Subscriptions] subscription.listSubscriptions is unavailable from Recharge SDK.'
          );
        }
        const response = await listSubs(session, {
          limit: 10,
          sort_by: 'id-asc',
          status: 'Active',
        });
        let subs = [];
        if (response && Array.isArray(response.subscriptions)) {
          subs = response.subscriptions;
        } else if (Array.isArray(response)) {
          subs = response;
        }
        return { subscriptions: subs, summariesById: {} };
      }

      if (!getPortalSessionExt || !getSubscriptionsExt || !listChargesExt) {
        console.warn(
          '[Cancel Subscriptions] etUpdateMealsExtensions helpers unavailable; falling back to bare subscriptions.'
        );
        return basicList();
      }

      try {
        const session = await getPortalSessionExt();
        const subs = await getSubscriptionsExt(session);
        const safeSubs = Array.isArray(subs) ? subs : [];

        const activeSubs = safeSubs.filter(function (entry) {
          const status = String(entry && entry.status ? entry.status : '')
            .trim()
            .toLowerCase();
          return status === 'active';
        });

        let charges = [];
        try {
          const chargesResponse = await listChargesExt(session, {
            status: 'queued',
            limit: 250,
            sort_by: 'scheduled_at-asc',
          });
          charges = Array.isArray(chargesResponse)
            ? chargesResponse
            : (chargesResponse && chargesResponse.charges) || [];
        } catch (error) {
          console.warn(
            '[Cancel Subscriptions] Unable to load queued charges for price summaries.',
            error
          );
        }

        function resolveNextChargeForSubscription(sub) {
          if (!Array.isArray(charges) || !charges.length) return null;

          if (sub.address_id) {
            const candidateCharges = charges.filter(function (charge) {
              if (String(charge.address_id) !== String(sub.address_id)) return false;
              if (Array.isArray(charge.line_items)) {
                return charge.line_items.some(function (li) {
                  return String(li.purchase_item_id) === String(sub.id);
                });
              }
              return false;
            });
            if (candidateCharges.length > 0) {
              candidateCharges.sort(function (a, b) {
                const da = new Date(
                  a.scheduled_at
                );
                const db = new Date(
                  b.scheduled_at
                );
                const ta = Number.isFinite(da.getTime())
                  ? da.getTime()
                  : Number.MAX_SAFE_INTEGER;
                const tb = Number.isFinite(db.getTime())
                  ? db.getTime()
                  : Number.MAX_SAFE_INTEGER;
                return ta - tb;
              });
              return candidateCharges[0];
            }
          }

          const subCharges = charges.filter(function (charge) {
            return String(charge.subscription_id) === String(sub.id);
          });
          if (subCharges.length > 0) {
            subCharges.sort(function (a, b) {
              const da = new Date(
                a.scheduled_at
              );
              const db = new Date(
                b.scheduled_at
              );
              const ta = Number.isFinite(da.getTime())
                ? da.getTime()
                : Number.MAX_SAFE_INTEGER;
              const tb = Number.isFinite(db.getTime())
                ? db.getTime()
                : Number.MAX_SAFE_INTEGER;
              return ta - tb;
            });
            return subCharges[0];
          }

          return null;
        }

        const summariesById = {};

        activeSubs.forEach(function (sub) {
          const nextCharge = resolveNextChargeForSubscription(sub);

          let deliveryDate = null;
          if (nextCharge) {
            const rawDate = nextCharge.scheduled_at || null;
            if (rawDate) {
              const d = new Date(String(rawDate));
              if (Number.isFinite(d.getTime())) {
                deliveryDate = d;
              }
            }
          }

          let totalAmount = null;
          let currencyCode =
            (nextCharge && nextCharge.currency) || sub.currency || 'USD';

          if (nextCharge) {
            const candidates = [
              nextCharge.total_price,
              nextCharge.total,
              nextCharge.amount,
              nextCharge.subtotal_price,
            ];
            for (let i = 0; i < candidates.length; i++) {
              const val = candidates[i];
              if (val == null) continue;
              const num =
                typeof val === 'number'
                  ? val
                  : Number(String(val).replace(/[^0-9.-]/g, ''));
              if (Number.isFinite(num)) {
                totalAmount = num;
                break;
              }
            }
          }

          let totalFormatted = '';
          if (totalAmount != null) {
            try {
              totalFormatted = new Intl.NumberFormat(undefined, {
                style: 'currency',
                currency: String(currencyCode || 'USD'),
              }).format(totalAmount);
            } catch (error) {
              totalFormatted =
                '$' +
                (typeof totalAmount === 'number'
                  ? totalAmount.toFixed(2)
                  : String(totalAmount));
            }
          }

          summariesById[String(sub.id)] = {
            subscriptionId: sub.id,
            deliveryDate: deliveryDate,
            currencyCode: currencyCode,
            totalAmount: totalAmount,
            totalFormatted: totalFormatted,
          };
        });

        return {
          subscriptions: activeSubs,
          summariesById: summariesById,
        };
      } catch (error) {
        console.warn(
          '[Cancel Subscriptions] Failed to load subscriptions with summaries; falling back.',
          error
        );
        return basicList();
      }
    }

    let selectionModalOverlay = null;
    let selectionModalState = {
      selectedSubscriptionId: null,
      summariesById: {},
    };
    let paymentMethodsCancelInProgress = false;

    function ensureSelectionModal() {
      if (selectionModalOverlay && document.body.contains(selectionModalOverlay)) {
        return selectionModalOverlay;
      }

      const overlay = document.createElement('div');
      overlay.id = 'subscription-selection-modal';
      overlay.className = 'recharge-theme aff-modal-wrapper';
      overlay.style.display = 'none';

      overlay.innerHTML =
        '<div class="et-update-meals-subscription-modal" data-role="subscription-modal" tabindex="-1">' +
        '  <div class="et-update-meals-subscription-modal__header">' +
        '    <h2 class="et-update-meals-subscription-modal__title">Choose subscription</h2>' +
        '    <button type="button" class="et-update-meals-subscription-modal__close" data-role="close-subscription-modal" aria-label="Close">&times;</button>' +
        '  </div>' +
        '  <div class="et-update-meals-subscription-modal__body">' +
        '    <p class="et-update-meals-subscription-modal__subtitle">Choose which subscription to be cancelled.</p>' +
        '    <div class="et-update-meals-subscription-modal__list" id="subscription-list" data-role="subscription-list"></div>' +
        '    <div class="et-update-meals-subscription-modal__actions">' +
        '      <button type="button" class="et-update-meals-subscription-modal__button et-update-meals-subscription-modal__button--ghost" data-role="cancel-subscription-modal">Close</button>' +
        '      <button type="button" class="et-update-meals-subscription-modal__button et-update-meals-subscription-modal__button--danger" data-role="confirm-cancel-subscription">Cancel subscription</button>' +
        '    </div>' +
        '  </div>' +
        '</div>';

      overlay.addEventListener('click', function (event) {
        if (event.target === overlay) {
          SubscriptionSelectionModal.close();
        }
      });

      document.body.appendChild(overlay);

      const modal = overlay.querySelector('[data-role="subscription-modal"]');
      const closeBtn = overlay.querySelector(
        '[data-role="close-subscription-modal"]'
      );
      const cancelBtn = overlay.querySelector(
        '[data-role="cancel-subscription-modal"]'
      );
      if (closeBtn) {
        closeBtn.addEventListener('click', function () {
          SubscriptionSelectionModal.close();
        });
      }
      if (cancelBtn) {
        cancelBtn.addEventListener('click', function () {
          SubscriptionSelectionModal.close();
        });
      }

      selectionModalOverlay = overlay;

      window.SubscriptionSelectionModal = {
        modal: overlay,
        open: function () {
          this.modal.style.display = 'flex';
        },
        close: function () {
          this.modal.style.display = 'none';
        },
      };

      return overlay;
    }

    function openSelectionModal(subscriptions, summariesById) {
      const overlay = ensureSelectionModal();
      const modal = overlay.querySelector('[data-role="subscription-modal"]');
      const list = overlay.querySelector('#subscription-list');
      if (!modal || !list) return;

      list.innerHTML = '';
      selectionModalState.selectedSubscriptionId = null;
      selectionModalState.summariesById = summariesById || {};

      subscriptions.forEach(function (subscription) {
        const subscriptionId = subscription && subscription.id;
        if (!subscriptionId) return;

        let displayText = 'Subscription';
        const parts = [];

        const summary =
          selectionModalState.summariesById[String(subscriptionId)] || null;

        if (summary && summary.deliveryDate instanceof Date) {
          try {
            const dayOfWeek = new Intl.DateTimeFormat(undefined, {
              weekday: 'long',
            }).format(summary.deliveryDate);
            parts.push(dayOfWeek);
          } catch (error) {
            console.error('[Cancel Subscriptions] Failed to format delivery date:', error);
          }
        }

        if (summary && summary.totalFormatted) {
          parts.push(summary.totalFormatted);
        }

        if (parts.length > 0) {
          displayText = displayText + ' - ' + parts.join(' - ');
        }

        const item = document.createElement('button');
        item.type = 'button';
        item.className = 'et-update-meals-subscription-modal__item';
        item.setAttribute('data-subscription-id', String(subscriptionId));
        item.setAttribute('data-role', 'subscription-option');
        item.innerHTML =
          '<div class="et-update-meals-subscription-modal__item-text">' +
          '<div class="et-update-meals-subscription-modal__item-title">' +
          displayText +
          '</div>' +
          '</div>' +
          '<div class="et-update-meals-subscription-modal__item-indicator" aria-hidden="true">\u2713</div>';

        item.addEventListener('click', function (e) {
          e.stopPropagation();
          selectionModalState.selectedSubscriptionId = subscriptionId;
          try {
            const activeEls = list.querySelectorAll(
              '.et-update-meals-subscription-modal__item--active'
            );
            activeEls.forEach(function (el) {
              el.classList.remove(
                'et-update-meals-subscription-modal__item--active'
              );
            });
          } catch (error) {
            console.error('[Cancel Subscriptions] Failed to remove active class:', error);
          }
          item.classList.add(
            'et-update-meals-subscription-modal__item--active'
          );
        });

        list.appendChild(item);
      });

      const confirmBtn = modal.querySelector(
        '[data-role="confirm-cancel-subscription"]'
      );
      if (confirmBtn) {
        confirmBtn.onclick = function (e) {
          e.preventDefault();
          e.stopPropagation();
          const id = selectionModalState.selectedSubscriptionId;
          if (!id) {
            alert('Please select a subscription to be cancelled.');
            return;
          }
          try {
            showCancelSubscriptionModal(id, {
              onError: function (message) {
                var msg =
                  message ||
                  'Unable to open cancellation page. Please try again or contact support.';
                alert(msg);
              },
            });
          } finally {
            SubscriptionSelectionModal.close();
          }
        };
      }

      SubscriptionSelectionModal.open();
    }

    async function handlePaymentMethodsCancelClick() {
      if (paymentMethodsCancelInProgress) {
        return;
      }
      paymentMethodsCancelInProgress = true;

      var triggerButton = document.getElementById(
        'cancel-subscription-footer-button'
      );
      var originalText = null;
      var originalDisabled = null;
      if (triggerButton) {
        originalText = triggerButton.textContent;
        originalDisabled = triggerButton.disabled;
        triggerButton.disabled = true;
        triggerButton.textContent = 'Loading…';
      }

      try {
        const result = await loadActiveSubscriptionsWithSummaries();
        const subscriptions = (result && result.subscriptions) || [];
        const summariesById = (result && result.summariesById) || {};

        if (!subscriptions || subscriptions.length === 0) {
          alert("You don't have any subscription to be cancelled.");
          return;
        }

        if (subscriptions.length === 1) {
          showCancelSubscriptionModal(subscriptions[0].id, {
            onError: function (message) {
              var msg =
                message ||
                'Unable to open cancellation page. Please try again or contact support.';
              alert(msg);
            },
          });
          return;
        }

        openSelectionModal(subscriptions, summariesById);
      } catch (error) {
        console.error(
          '[Cancel Subscriptions] Failed to handle cancel click on payment methods page:',
          error
        );
        alert(
          'Unable to load subscriptions. Please try again or contact support.'
        );
      } finally {
        paymentMethodsCancelInProgress = false;
        if (triggerButton) {
          triggerButton.disabled = originalDisabled === null ? false : originalDisabled;
          if (originalText !== null) {
            triggerButton.textContent = originalText;
          }
        }
      }
    }

    function ensurePaymentMethodsSlotTemplate() {
      if (!isPaymentMethodsPage()) return;
      if (
        document.querySelector(
          'script[type="text/html"][data-recharge-slot="payment_methods.footer"]'
        )
      ) {
        return;
      }
      var tpl = document.createElement('script');
      tpl.type = 'text/html';
      tpl.setAttribute('data-recharge-slot', 'payment_methods.footer');
      tpl.text =
        '<div id="cancel-subscription-footer-container" style="margin-top: 16px; text-align: left;">' +
        '<button type="button" id="cancel-subscription-footer-button" class="et-shipment-modal-link et-shipment-modal-link--danger">Cancel subscription</button>' +
        '</div>';
      document.head.appendChild(tpl);
    }

    function initPaymentMethodsCancelButtonFromDom(root) {
      if (!isPaymentMethodsPage()) return;
      var scope = root || document;
      var btn = scope.getElementById
        ? scope.getElementById('cancel-subscription-footer-button')
        : document.getElementById('cancel-subscription-footer-button');
      if (!btn) {
        btn = document.getElementById('cancel-subscription-footer-button');
      }
      if (!btn || btn.__etCancelInit) return;
      btn.__etCancelInit = true;
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        handlePaymentMethodsCancelClick();
      });
    }

    ensurePaymentMethodsSlotTemplate();

    document.addEventListener('Recharge::slot::mounted', function () {
      if (!isPaymentMethodsPage()) return;
      initPaymentMethodsCancelButtonFromDom(document);
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        ensurePaymentMethodsSlotTemplate();
        initPaymentMethodsCancelButtonFromDom(document);
      });
    } else {
      ensurePaymentMethodsSlotTemplate();
      initPaymentMethodsCancelButtonFromDom(document);
    }

    window.etRechargeSubscriptionCancel = Object.freeze({
      getPortalSession: getPortalSession,
      getChurnLandingPageUrl: getChurnLandingPageUrl,
      getActiveChurnLandingPageURL: getActiveChurnLandingPageURL,
      redirectToChurnPage: redirectToChurnPage,
      clearPortalSessionCache: clearPortalSessionCache,
      showCancelSubscriptionModal: showCancelSubscriptionModal,
      showCancelSubscriptionModalFallback: showCancelSubscriptionModalFallback,
      handleCancelSubscriptionClick: handleCancelSubscriptionClick,
      redirectToSubscriptionCreateIfNoActive: redirectToSubscriptionCreateIfNoActive,
    });
  })();
